import { ActionReducerMap } from "@ngrx/store";
import { SharedState, sharedReducer } from "../shared/store/shared.reducers";
import { ProductsState, productsReducer } from "../features/produits/store/produits.reducers";
import { CategoriesState, categoriesReducer } from "../features/categories/store/categories.reducers";
import { TagsState, tagsReducer } from "../features/tags/store/tags.reducers";
import { BrandsState, brandsReducer } from "../features/brands/store/brands.reducers";
import { CustomersState, customersReducer } from "../features/customers/store/customers.reducers";
import { CatalogsState, catalogsReducer } from "../features/catalogs/store/catalogs.reducers";
import { CompaniesGroupsState, companiesGroupsReducer } from "../features/companies-groups/store/companies-groups.reducers";
import { authReducer, AuthState } from "../features/auth/authentication/store/auth.reducer";
import { quotationsReducer, quotationsState } from "../features/quotations/store/quotations.reducers";
import { ordersReducer, ordersState } from "../features/orders/store/orders.reducers";
import { importProductsReducer, ImportProductsState } from "../features/imports/store/imports.reducers";
import { SegmentsState, segmentsReducer } from "../features/segments/store/segments.reducers";
import { settingsReducer, SettingsState } from "../features/settings/store/settings.reducers";
import { comparatorsReducer, ComparatorState } from "../features/comparator/store/comparator.reducers";
import { suppliersReducer, SuppliersState } from "../features/suppliers/store/suppliers.reducers";
import { agentsReducer, AgentsState } from "../features/agents/store/agents.reducers";
import { warehousesReducer, WarehousesState } from "../features/warehouses/store/warehouses.reducers";
import { pricebooksReducer, PricebooksState } from "../features/pricebook/store/pricebook.reducers";
import { smartInboxReducer, SmartInboxState } from "../features/smart-inbox/store/smart-inbox.reducers";
import { aiChatReducer, AiChatState } from "../features/ai-chat/store/ai-chat.reducers";
import { knowledgeBaseReducer, KnowledgeBaseState } from "../features/knowledge-base/store/knowledge-base.reducers";
import { ProductAliasesState, productAliasesReducer } from "../features/knowledge-base/store/aliases.reducers";
import { ExternalReferencesState, externalReferencesReducer } from "../features/knowledge-base/store/external-references.reducers";
import { IgnoreCodesState, ignoreCodesReducer } from "../features/knowledge-base/store/ignore-codes.reducers";
import { PriceObservationsState, priceObservationsReducer } from "../features/knowledge-base/store/price-observations.reducers";
import { PreferredProductsState, preferredProductsReducer } from "../features/knowledge-base/store/preferred-products.reducers";
import { CustomerEmailsState, customerEmailsReducer } from "../features/knowledge-base/store/customer-emails.reducers";
import { LocationEmailsState, locationEmailsReducer } from "../features/knowledge-base/store/location-emails.reducers";
import { LocationShippingExclusionsState, locationShippingExclusionsReducer } from "../features/knowledge-base/store/location-shipping-exclusions.reducers";
import { notificationReducer, NotificationState } from "../features/notifications/store/notification.reducers";
import { permissionsReducer, PermissionsState } from "./store/permissions/permissions.reducer";
import { fieldVisibilityReducer, FieldVisibilityState } from "./store/field-visibility/field-visibility.reducer";
import { workflowsReducer, WorkflowsState } from "../features/workflows/store/workflows.reducers";

export interface AppState {
  auth: AuthState;
  permissions: PermissionsState;
  fieldVisibility: FieldVisibilityState;
  shared: SharedState;
  products: ProductsState;
  categories: CategoriesState;
  tags: TagsState;
  brands: BrandsState;
  customers: CustomersState;
  catalogs: CatalogsState;
  companiesGroups: CompaniesGroupsState;
  quotations: quotationsState;
  orders: ordersState;
  importProducts: ImportProductsState
  segments: SegmentsState,
  settings: SettingsState,
  comparators: ComparatorState,
  suppliers: SuppliersState,
  warehouses: WarehousesState,
  agents: AgentsState, 
  pricebooks: PricebooksState,
  smartInbox: SmartInboxState;
  aiChat: AiChatState;
  knowledgeBase: KnowledgeBaseState;
  productAliases: ProductAliasesState;
  externalReferences: ExternalReferencesState;
  ignoreCodes: IgnoreCodesState;
  priceObservations: PriceObservationsState;
  preferredProducts: PreferredProductsState;
  customerEmails: CustomerEmailsState;
  locationEmails: LocationEmailsState;
  locationShippingExclusions: LocationShippingExclusionsState;
  notifications: NotificationState;
  workflows: WorkflowsState;
}
export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  permissions: permissionsReducer,
  fieldVisibility: fieldVisibilityReducer,
  shared: sharedReducer,
  products: productsReducer,
  categories: categoriesReducer,
  tags: tagsReducer,
  brands: brandsReducer,
  customers: customersReducer,
  catalogs: catalogsReducer,
  companiesGroups: companiesGroupsReducer,
  quotations: quotationsReducer,
  orders: ordersReducer,
  importProducts: importProductsReducer,
  segments: segmentsReducer,
  settings: settingsReducer,
  comparators: comparatorsReducer,
  suppliers: suppliersReducer,
  agents: agentsReducer,
  warehouses: warehousesReducer,
  pricebooks: pricebooksReducer,
  smartInbox: smartInboxReducer,
  aiChat: aiChatReducer,
  knowledgeBase: knowledgeBaseReducer,
  productAliases: productAliasesReducer,
  externalReferences: externalReferencesReducer,
  ignoreCodes: ignoreCodesReducer,
  priceObservations: priceObservationsReducer,
  preferredProducts: preferredProductsReducer,
  customerEmails: customerEmailsReducer,
  locationEmails: locationEmailsReducer,
  locationShippingExclusions: locationShippingExclusionsReducer,
  notifications: notificationReducer,
  workflows: workflowsReducer,
};
